<template>
  <section class="quotes">
    <RichText :field="quotes.primary.header" />

    <div v-for="(quote, i) in quotes.items" :key="`quote-${i}`" class="quote">
      <RichText :field="quote.quote" class="quote-content sub-heading" />
      <div class="person">
        <div class="person-name">
          <RichText :field="quote.name" />
          <RichText :field="quote.title" />
        </div>
        <RichImage :field="quote.person" />
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    quotes: {
      type: Object,
      default: undefined
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../scss/base/colors';
@import '../scss/helpers/mixins';

.quotes {
  max-width: calc(23 * 60px);
  margin: 0 auto;
  padding: 0 20px;
}
.quote {
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  .quote-content {
    display: flex;

    &:before {
      content: '\201C';
      display: flex;
      font-size: 72px;
      line-height: 48px;
      margin-right: 10px;
      color: $black;
    }
  }
}
.person {
  display: flex;

  img {
    max-width: 60px;
    padding: 5px;
  }

  .person-name {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    margin-right: 30px;
    text-align: right;

    ::v-deep p {
      margin: 0;
    }
  }
}

@include breakpoint(M) {
  .quote {
    ::v-deep p {
      font-size: 36px;
    }
  }
  .person {
    img {
      max-width: 120px;
      padding: 0;
    }
  }
}
</style>
